module.exports = __webpack_public_path__ + "static/img/icon_logo.be7903de.png";